import { render, staticRenderFns } from "./metricDetails.vue?vue&type=template&id=37f041d6"
import script from "./metricDetails.vue?vue&type=script&lang=js"
export * from "./metricDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports